import { apiClient } from "@api/apiClient";

import { adaptPatentListData } from "./adaptPatentList.data";

import type {
  PatentFilteringData,
  PostPatentListFilterApiResponse,
} from "@interface/patentList.interface";

const API_ENDPOINT = {
  patentList: "/edb/internal/patent/search",
};

export const patentListApis = {
  post: async (filteringData: PatentFilteringData) => {
    const { data } = await apiClient.post<PostPatentListFilterApiResponse>(
      API_ENDPOINT.patentList,
      filteringData,
    );

    return adaptPatentListData(data);
  },
};
